import axios from "axios";

export const getTerritoryRegions = (country_id, callback) => {
  var promise = axios({
    method: "get",
    url: `/api/territory_countries/${country_id}/territory_regions`
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};
